export default "__VITE_ASSET__BLNJ0dZg__"